import { getFlowConcentrationTime, getRainfallHeight, getTotalDrainageDischarge } from '../../../calculation';
import { IInputDischarge } from '../../iProject';

export const handleCatchmentAreaChange = (value: number, discharge: IInputDischarge) => {
    const { mainChannelLength, parameterA, parameterN, averageCatchmentElevation, closureSectionElevation, curveNumber } = discharge;
    discharge.flowConcentrationTime = getFlowConcentrationTime(value, mainChannelLength!, averageCatchmentElevation!, closureSectionElevation!);
    discharge.rainfallHeight = getRainfallHeight(parameterA!, parameterN!, discharge.flowConcentrationTime!);
    discharge.totalDischargeToBeDrained = getTotalDrainageDischarge(curveNumber!, value, discharge.rainfallHeight!, discharge.flowConcentrationTime!);
};

export const handleMainChannelLengthChange = (value: number, discharge: IInputDischarge) => {
    const { catchmentArea, parameterA, parameterN, averageCatchmentElevation, closureSectionElevation, curveNumber } = discharge;
    discharge.flowConcentrationTime = getFlowConcentrationTime(catchmentArea!, value, averageCatchmentElevation!, closureSectionElevation!);
    discharge.rainfallHeight = getRainfallHeight(parameterA!, parameterN!, discharge.flowConcentrationTime!);
    discharge.totalDischargeToBeDrained = getTotalDrainageDischarge(curveNumber!, catchmentArea!, discharge.rainfallHeight!, discharge.flowConcentrationTime!);
};

export const handleAverageCatchmentElevationChange = (value: number, discharge: IInputDischarge) => {
    const { catchmentArea, parameterA, parameterN, mainChannelLength, closureSectionElevation, curveNumber } = discharge;
    discharge.flowConcentrationTime = getFlowConcentrationTime(catchmentArea!, mainChannelLength!, value, closureSectionElevation!);
    discharge.rainfallHeight = getRainfallHeight(parameterA!, parameterN!, discharge.flowConcentrationTime!);
    discharge.totalDischargeToBeDrained = getTotalDrainageDischarge(curveNumber!, catchmentArea!, discharge.rainfallHeight!, discharge.flowConcentrationTime!);
};

export const handleClosureSectionElevationChange = (value: number, discharge: IInputDischarge) => {
    const { catchmentArea, parameterA, parameterN, mainChannelLength, averageCatchmentElevation, curveNumber } = discharge;
    discharge.flowConcentrationTime = getFlowConcentrationTime(catchmentArea!, mainChannelLength!, averageCatchmentElevation!, value);
    discharge.rainfallHeight = getRainfallHeight(parameterA!, parameterN!, discharge.flowConcentrationTime!);
    discharge.totalDischargeToBeDrained = getTotalDrainageDischarge(curveNumber!, catchmentArea!, discharge.rainfallHeight!, discharge.flowConcentrationTime!);
};

export const handleParameterAChange = (value: number, discharge: IInputDischarge) => {
    const { parameterN, flowConcentrationTime, curveNumber, catchmentArea } = discharge;
    discharge.rainfallHeight = getRainfallHeight(value, parameterN!, flowConcentrationTime!);
    discharge.totalDischargeToBeDrained = getTotalDrainageDischarge(curveNumber!, catchmentArea!, discharge.rainfallHeight!, flowConcentrationTime!);
};

export const handleParameterNChange = (value: number, discharge: IInputDischarge) => {
    const { parameterA, flowConcentrationTime, curveNumber, catchmentArea } = discharge;
    discharge.rainfallHeight = getRainfallHeight(parameterA!, value, flowConcentrationTime!);
    discharge.totalDischargeToBeDrained = getTotalDrainageDischarge(curveNumber!, catchmentArea!, discharge.rainfallHeight!, flowConcentrationTime!);
};

export const handleFlowConcentrationTimeChange = (value: number, discharge: IInputDischarge) => {
    const { parameterA, parameterN, curveNumber, catchmentArea } = discharge;
    discharge.rainfallHeight = getRainfallHeight(parameterA!, parameterN!, value);
    discharge.totalDischargeToBeDrained = getTotalDrainageDischarge(curveNumber!, catchmentArea!, discharge.rainfallHeight!, value);
};

export const handleCurveNumberChange = (value: number, discharge: IInputDischarge) => {
    const { rainfallHeight, flowConcentrationTime, catchmentArea } = discharge;
    discharge.totalDischargeToBeDrained = getTotalDrainageDischarge(value, catchmentArea!, rainfallHeight!, flowConcentrationTime!);
};

export const handleRainfallHeightChange = (value: number, discharge: IInputDischarge) => {
    const { curveNumber, flowConcentrationTime, catchmentArea } = discharge;
    discharge.totalDischargeToBeDrained = getTotalDrainageDischarge(curveNumber!, catchmentArea!, value, flowConcentrationTime!);
};
